import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { MenuButton } from 'components/Menu';
export function PrimaryMoveButton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    onClick = _ref.onClick,
    name = _ref.name;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var buttonLabel = name ? t('actions_move_selected_to', {
    name: name
  }) : t('actions_move_selected_here');
  return /*#__PURE__*/React.createElement(Button, {
    size: size,
    variant: "transparent",
    icon: "arrow-right",
    align: "left",
    onClick: onClick
  }, buttonLabel);
}
export function PrimaryAddContentButton(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'small' : _ref2$size,
    name = _ref2.name;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var buttonLabel = name ? t('actions_add_content_to', {
    name: name
  }) : t('actions_add_content');
  return /*#__PURE__*/React.createElement(MenuButton, {
    size: size,
    variant: "transparent",
    icon: "plus",
    iconRight: "chevron",
    align: "left"
  }, buttonLabel);
}
export function PrimaryAddSectionButton(_ref3) {
  var level = _ref3.level,
    onClick = _ref3.onClick,
    name = _ref3.name;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var addSectionLabel = name ? t('actions_add_section_to', {
    name: name
  }) : t('actions_add_section');
  var addSubsectionLabel = name ? t('actions_add_subsection_to', {
    name: name
  }) : t('actions_add_subsection');
  return /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "transparent",
    icon: "plus",
    align: "left",
    onClick: onClick
  }, level === 0 ? addSectionLabel : addSubsectionLabel);
}